import _ from "lodash";
import numeral from "numeral";

export default {
    computed: {
        enabledSelectedFilter() {
            return _.chain(this.value)
                .filter((filter) => {
                    return (
                        (filter.type === "text" && !_.isEmpty(filter.value)) ||
                        (filter.type === "max" && !_.isNil(filter.value)) ||
                        (_.isArray(filter.value) && _.size(filter.value) > 0) ||
                        (_.isBoolean(filter.value) && filter.value === true) ||
                        (_.isObject(filter.value) &&
                            (!_.isNil(filter.value.min) ||
                                !_.isNil(filter.value.max)))
                    );
                })
                .flatMap((filter) => {
                    if (_.isArray(filter.value)) {
                        return _.map(filter.value, (value) => {
                            return {
                                ...filter,
                                value,
                            };
                        });
                    }

                    return filter;
                })
                .map(filter => {
                    if (_.isNil(filter.label)) {
                        return {
                            ...filter,
                            label: this.capitalizeFilterCPO(filter)
                                ? "CPO"
                                : _.startCase(_.toLower(filter.value)),
                        };
                    } else if (filter.label.indexOf("%s") !== -1) {
                        filter.label = filter.label.replace("%s", filter.value);
                    } else if (filter.type === "range") {
                        const suffix = _.get(filter, "suffix", "");
                        const minLabel = _.isNil(filter.value.min)
                            ? "Any"
                            : numeral(filter.value.min).format(filter.label) +
                              suffix;
                        const maxLabel = _.isNil(filter.value.max)
                            ? "Any"
                            : numeral(filter.value.max).format(filter.label) +
                              suffix;

                        filter.label = minLabel + " - " + maxLabel;
                    } else if (filter.type === "max") {
                        const suffix = _.get(filter, "suffix", "");
                        filter.label =
                            numeral(filter.value).format(filter.label) +
                            suffix +
                            " or less";
                    } else {
                        filter.label = _.startCase(_.toLower(filter.label));
                    }

                    return filter;
                })
                .value();
        }
    },
    methods: {
        capitalizeFilterCPO(filter) {
            return filter.value.toLowerCase() === "cpo";
        },
    },
};
